(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-review-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rt-judgeme_carousel_section .jdgm-carousel .jdgm-carousel-item').forEach(function(jdgmItem){
    let reviewerNameHTML = jdgmItem.querySelector('.jdgm-carousel-item__reviewer-name-wrapper .jdgm-carousel-item__reviewer-name');
    let firstLetter = '<div class="first-letter">' + reviewerNameHTML.textContent.trim().charAt(0).toUpperCase() + '</div>';
    let varifyPurchashe = '<div class="name-and-verify-purchase"><div class="reviewer-name">'+ reviewerNameHTML.textContent +'</div><div class="verify-purchase"><img src="https://cdn.shopify.com/s/files/1/0550/8248/3769/files/Check_1.png?v=1686651900" alt="" width="6px" height="4px" />VERIFIED PURCHASE</div></div>';
    reviewerNameHTML.style.display = "none";
    jdgmItem.querySelector('.jdgm-carousel-item__timestamp').style.display = "none";
    reviewerNameHTML.insertAdjacentHTML('beforebegin', firstLetter);
    reviewerNameHTML.insertAdjacentHTML('afterend', varifyPurchashe);
  });

  } catch(e) { console.error(e); }
})();
})();
